module.exports = __webpack_public_path__ + "img/alarme_de_seguranca.5940d6ef.svg";